import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatIconModule} from '@angular/material/icon'


@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @Input() widthScreen:any;
  showMore = false;
  constructor() { }

  ngOnInit(): void {
  }

  doShowMore(){
    this.showMore = !this.showMore
  }

}
